import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_group_task_id: yup.number().label("Group task").required(),
    mr_group_sub_code: yup.string().label("Sub group task code").required().min(2).max(3),
    mr_group_sub_name: yup.string().label("Sub group task name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
})